// Ativa o comportamento de abrir o mega menu ao passar o mouse (desktop)
// Mantém acessibilidade por clique/teclado; só roda em telas desktop e ponteiro fino

(function () {
  var desktopMq = window.matchMedia('(min-width: 990px)');
  var finePointerMq = window.matchMedia('(pointer: fine)');

  var wired = false;
  var listeners = [];

  function forEachNode(list, cb) {
    Array.prototype.forEach.call(list, cb);
  }

  function closeAll(except) {
    var items = document.querySelectorAll('header details.mega-menu');
    forEachNode(items, function (d) {
      if (d !== except) d.open = false;
    });
  }

  function addListener(el, type, handler, opts) {
    el.addEventListener(type, handler, opts || false);
    listeners.push({ el: el, type: type, handler: handler });
  }

  function removeAllListeners() {
    listeners.forEach(function (l) {
      l.el.removeEventListener(l.type, l.handler);
    });
    listeners = [];
  }

  function wire() {
    // Habilita somente em desktop com ponteiro fino
    if (!desktopMq.matches || !finePointerMq.matches) {
      if (wired) {
        removeAllListeners();
        wired = false;
      }
      return;
    }

    if (wired) return;

    var items = document.querySelectorAll('header details.mega-menu');
    if (!items.length) return;

    forEachNode(items, function (d) {
      var openTimer = null;
      var closeTimer = null;

      function handleEnter() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        openTimer = setTimeout(function () {
          closeAll(d);
          d.open = true;
        }, 120);
      }

      function handleLeave() {
        if (openTimer) {
          clearTimeout(openTimer);
          openTimer = null;
        }
        closeTimer = setTimeout(function () {
          d.open = false;
        }, 180);
      }

      addListener(d, 'mouseenter', handleEnter);
      addListener(d, 'mouseleave', handleLeave);

      // Se o foco sair do details completamente, fecha após um pequeno delay
      addListener(d, 'focusout', function (e) {
        // Fecha apenas se o foco foi para fora do details
        var related = e.relatedTarget;
        if (!related || !d.contains(related)) {
          closeTimer = setTimeout(function () {
            d.open = false;
          }, 180);
        }
      });
    });

    // Fecha todos com ESC
    addListener(document, 'keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeAll();
      }
    });

    wired = true;
  }

  // Wire inicial e ao trocar o breakpoint ou tipo de ponteiro
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }

  // Compatível com Safari (addEventListener em MediaQueryList nem sempre existe)
  function onChange(mq, cb) {
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', cb);
    else if (typeof mq.addListener === 'function') mq.addListener(cb);
  }

  onChange(desktopMq, function () {
    removeAllListeners();
    wired = false;
    wire();
  });
  onChange(finePointerMq, function () {
    removeAllListeners();
    wired = false;
    wire();
  });
})();


